import React, { Component } from 'react'
import classNames from 'classnames'
import Header from './Header'
import Footer from '../Footer'
import treeImg from '../images/tree-silhouette1.png'
import woodTxLg from '../images/ground-tx-lg.jpg'

export default class LandingPageFrame extends Component {
  /**
   * Render the component
   * @returns
   */
  render () {
    // region CSS
    const lpStyle = {
      margin: 0,
      padding: 0,
      minHeight: '100%',
      overflow: 'hidden'
    }

    const topSpacerClasses = classNames({
      'visible-xs': true,
      'visible-sm': true,
      'visible-md': true,
      'visible-lg': false
    })

    const headerToBtnSpacer = {
      width: '100%',
      height: 75
    }

    const headerToBtnSpacerLg = {
      width: '100%',
      height: 120
    }

    const woodTxStyle = {
      backgroundImage: `url(${woodTxLg})`,
      height: 'auto',
      minHeight: '55vh',
      width: '100vw',
      zIndex: -100
    }

    const treeClasses = classNames({
      'visible-md': true,
      'visible-lg': true
    })

    const treeStyleSm = {
      position: 'absolute',
      top: -20,
      left: 805,
      zIndex: 200
    }

    const secondTreeStyleLg = {
      position: 'absolute',
      top: 150,
      left: 1295
    }
    const secondTreeImgStyleLg = {
      height: 297,
      width: 300
    }
    const childrenStyle = {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap'
    }
    // endregion

    return (
      <div style={lpStyle}>
        <Header />
        <div style={headerToBtnSpacer} className={topSpacerClasses} />
        <div style={headerToBtnSpacerLg} className='visible-lg' />
        <div style={woodTxStyle}>
          <div style={childrenStyle} className={'landingPageBtnSpacing'}>
            {this.props.children}
          </div>
          <div style={treeStyleSm} className={treeClasses}>
            <img src={treeImg} alt='Tree' />
          </div>
          <div style={secondTreeStyleLg} className='visible-lg'>
            <img style={secondTreeImgStyleLg} src={treeImg} alt='Tree' />
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/landing-elements/LandingPageFrame.js